<div *ngIf="mappedTypes.length" class="size-group__container">
    <div *ngFor="let grouppedTypes of mappedTypes | groupBy: 'BookingTypeId'" class="size-group">
        <label *ngIf="grouppedTypes[0] != 0 && grouppedTypes[1][0].CoverTypeId > 0" for="" class="size-group__header">{{bookingTypeName[grouppedTypes[0]]}}</label>
        <div *ngFor="let cover of grouppedTypes[1]" class="size-group__cover">
            <div class="dining-input-options type-input-field-options p-2 mb-3 d-flex justify-content-center booking-type-fields">
                <div class="wd-60 type-field-headers">{{cover.CoverTypeId ? coverTypeName[cover.CoverTypeId] : (cover.BookingTypeId ? bookingTypeName[cover.BookingTypeId] : ('SelectCoverSize' | translate))}}</div>
                <div class="wd-40">
                <div
                    class="type-field-minus-icon wd-35 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
                    (click)="parySizeChange('prev', cover)" [class.disabledArrow]="cover.Covers === 0">&#45;</div>
                <div class="wd-30 d-flex">
                    <mat-form-field class="input-border-bottom seating-fields text-align-center" id="full-width">
                    <input type="number" [(ngModel)]="cover.Covers"
                        (ngModelChange)="onSizeChange()" matInput
                        [matAutocomplete]="auto">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                        <mat-option [value]="option" *ngFor="let option of sizeArr;">
                        {{option}}
                        </mat-option>
                    </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div
                    class="type-field-plus-icon wd-35 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                    (click)="parySizeChange('next', cover)" [class.disabledArrow]="cover.Covers === maxSize">
                    &#43;</div>
                </div>
            </div>
        </div>
    </div>
</div>